import { HTTP, HTTP_CONFIG } from '../http';

export default {
  login(params) {
    if (HTTP_CONFIG.backOfficeVersion === HTTP_CONFIG.BACKOFFICE_V2) {
      return HTTP.post('/authenticate/authenticateAsAdmin', params);
    }
    return HTTP.post('index.php?api=Authenticate&a=authenticateAsAdmin', params);
  },
  logout(params) {
    if (HTTP_CONFIG.backOfficeVersion === HTTP_CONFIG.BACKOFFICE_V2) {
      return HTTP.post('/SupportAdmin/logout', params)
        .then(response => response.data);
    }
    return HTTP.post('index.php?api=Authenticate&a=logout', params)
      .then(response => response.data);
  },
};
